import carIcon from "../../../../../assets/icons/car_marker.png";
import motoIcon from "../../../../../assets/icons/moto_marker.png";
import camionIcon from "../../../../../assets/icons/camion_marker.png";
import furgonIcon from "../../../../../assets/icons/furgon_marker.png";
import busIcon from "../../../../../assets/icons/bus_marker.png";
import camionetaIcon from "../../../../../assets/icons/camioneta_marker.png";
import { Marker } from "@react-google-maps/api";
import { TravelUrbanRel } from "../../../../../api/travel_urban/travelUrbanModel";

const vehicleIcons: Record<number, string> = {
    1: carIcon,
    2: motoIcon,
    3: camionIcon,
    4: furgonIcon,
    5: busIcon,
    6: camionetaIcon
};

type Props = {
    lat: number;
    lng: number;
    travel_urban: TravelUrbanRel;
};

const TravelUrbanSharingMarkerDriver = ({ travel_urban, lat, lng }: Props) => {
    const typeId = travel_urban?.vehicle?.vehicle_type_id ?? 1;
    const iconSrc = vehicleIcons[typeId] || carIcon;
    
    return <Marker
        key={`userDriversMarkers-${travel_urban?.user_driver_id}`}
        position={{ lat, lng }}
        draggable={false}
        // onClick={() => props.onClick(props.userDriver)}
        icon={{
            url: iconSrc,
            scaledSize: new google.maps.Size(70, 70),
            rotation: travel_urban?.user_driver?.bearing ?? 0,
        }}
    />
};

export default TravelUrbanSharingMarkerDriver;